// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"282":"a974ae4e","772":"fbdbf988"}[chunkId] + ".chunk.js";
};